import { module } from 'modujs';

//const axios = require( 'axios' ).default;

export default class extends module {

    constructor( m ) {
        super( m );
        this.el.addEventListener( 'submit', this.onSubmit.bind( this ) );
    }

    onSubmit( ev ) {
        ev.preventDefault();
        axios.post( this.el.getAttribute( 'action' ), new FormData( this.el ), { withCredentials: true } ).then( this.onSuccess.bind( this ) ).catch( this.onError.bind( this ) );
    }

    onSuccess( response ) {
        let message;
        if( response.data.redirect ){
            window.location.href = response.data.redirect;
            return;
        }
        if( response.data.reload ){
            window.location.reload();
        }
        if( typeof response.data.messages === 'object' ){
            message = Object.values( response.data.messages )[ 0 ].text || Object.values( response.data.messages )[ 0 ];
        } else {
            message = response.data.message;
        }
        let data = response.data.data ? response.data.data : false;
        this.el.dispatchEvent( new CustomEvent( 'response', { detail: { success : response.data.success, message, data  } } ) );
        if( response.data.success ){
            this.updateBindings();
        }

    }

    updateBindings(){
        let duplicates = [];
        for (let [key, value] of new FormData( this.el ) ) {
            if( duplicates.includes( key ) ) continue;
            else duplicates.push( key );
            document.querySelectorAll( `[data-bind-value="${key}"]`).forEach( el =>{
                let currentElement = this.el.querySelector( `[name="${key}"]` );
                if( currentElement.tagName === 'SELECT' ){
                    let values = [];
                    [...currentElement.selectedOptions].forEach( option => values.push( option.textContent ));
                    el.textContent = values.join( ', ' );
                } else {
                    el.innerHTML = this.sanitizeHTML( value ).replace(/(?:\r\n|\r|\n)/g, '<br/>');
                    console.info( this.sanitizeHTML( value ).replace(/(?:\r\n|\r|\n)/g, '<br/>') );
                }

            })
        }
    }

    sanitizeHTML(str) {
        let temp = document.createElement('div');
        temp.textContent = str;
        return temp.innerHTML;
    };

    onError( error ) {
        if( ! navigator.onLine ){
            this.el.dispatchEvent( new CustomEvent( 'response', { detail: { success : false, message : 'Your browser is offline' } } ) );
        } else {
            this.el.dispatchEvent( new CustomEvent( 'response', { detail: { success : false, message : 'Something is wrong, please refresh the page' } } ) );
        }

    }

}
